var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 23.3333H14M14 23.3333H17.5M14 23.3333V19.8333M14 19.8333H22.1667C22.7855 19.8333 23.379 19.5875 23.8166 19.1499C24.2542 18.7123 24.5 18.1188 24.5 17.5V6.99999C24.5 6.38115 24.2542 5.78766 23.8166 5.35007C23.379 4.91249 22.7855 4.66666 22.1667 4.66666H5.83333C5.21449 4.66666 4.621 4.91249 4.18342 5.35007C3.74583 5.78766 3.5 6.38115 3.5 6.99999V17.5C3.5 18.1188 3.74583 18.7123 4.18342 19.1499C4.621 19.5875 5.21449 19.8333 5.83333 19.8333H14Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.cf3001b2745b07886312359da78c6d2d.svg";
export { ForwardRef as ReactComponent };